(() => {
  const numericVariantId = (value) => {
    const id = String(value || '').split('/').pop();
    return /^\d+$/.test(id) ? id : '';
  };

  const refreshCart = async () => {
    if (typeof window.refreshCart === 'function') {
      const result = window.refreshCart(true);
      if (result && typeof result.then === 'function') await result;
      else await new Promise((resolve) => window.setTimeout(resolve, 250));
    }
  };

  document.querySelectorAll('[data-kk-was-root]').forEach((root) => {
    root.querySelectorAll('[data-kk-was-card]').forEach((card) => {
      const sizeButton = card.querySelector('[data-kk-was-size]');
      const fabricButtons = [...card.querySelectorAll('[data-kk-was-fabric]')];
      const cta = card.querySelector('[data-kk-was-cta]');
      const facts = card.querySelector('[data-kk-was-facts]');
      const designsContainer = card.querySelector('[data-kk-was-designs]');
      const designs = [...card.querySelectorAll('[data-kk-was-design]')];
      const addToCart = card.querySelector('[data-kk-was-add-to-cart]');
      const cartStatus = card.querySelector('[data-kk-was-cart-status]');
      let selectedFabric = '';
      let selectedVariantId = '';
      let cartBusy = false;

      const updateCartButton = () => {
        if (!addToCart) return;
        addToCart.disabled = cartBusy || !selectedFabric || !selectedVariantId;
        addToCart.setAttribute('aria-disabled', String(addToCart.disabled));
        addToCart.setAttribute('aria-busy', String(cartBusy));
      };

      const update = () => {
        const selectedButton = fabricButtons.find((button) => button.dataset.fabricKey === selectedFabric);
        fabricButtons.forEach((button) => {
          const selected = button.dataset.fabricKey === selectedFabric;
          button.setAttribute('aria-selected', String(selected));
          button.setAttribute('aria-pressed', String(selected));
        });
        if (cta) cta.textContent = selectedFabric ? 'Dein Lieblingsmuster entdecken' : 'Deinen Lieblingsstoff entdecken';
        if (facts) {
          facts.textContent = selectedButton?.dataset.fabricFacts || '';
          facts.hidden = !selectedFabric || !selectedButton?.dataset.fabricFacts;
        }
        if (designsContainer) designsContainer.hidden = !selectedFabric;
        designs.forEach((design) => {
          const visible = Boolean(selectedFabric) && design.dataset.fabricKey === selectedFabric;
          design.hidden = !visible;
        });
        updateCartButton();
      };

      sizeButton?.addEventListener('click', () => {
        root.querySelectorAll('[data-kk-was-size]').forEach((button) => button.setAttribute('aria-pressed', String(button === sizeButton)));
      });

      fabricButtons.forEach((button) => button.addEventListener('click', () => {
        if (selectedFabric === button.dataset.fabricKey) {
          selectedFabric = '';
          button.blur();
        } else {
          selectedFabric = button.dataset.fabricKey || '';
        }
        selectedVariantId = '';
        designs.forEach((design) => {
          design.classList.remove('is-selected');
          design.setAttribute('aria-checked', 'false');
        });
        update();
      }));

      designs.forEach((design) => design.addEventListener('click', () => {
        if (!selectedFabric || design.dataset.fabricKey !== selectedFabric) return;
        selectedVariantId = numericVariantId(design.dataset.variantId);
        designs.forEach((item) => {
          const selected = item === design;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-checked', String(selected));
        });
        updateCartButton();
      }));

      addToCart?.addEventListener('click', async () => {
        const variantId = numericVariantId(selectedVariantId);
        if (cartBusy || !variantId) return;
        cartBusy = true;
        updateCartButton();
        if (cartStatus) cartStatus.textContent = 'Wird in den Warenkorb gelegt …';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload?.description || payload?.message || 'Cart add failed');
          await refreshCart();
          if (cartStatus) cartStatus.textContent = 'Deine Wickelauflage wurde in den Warenkorb gelegt.';
        } catch (error) {
          if (cartStatus) cartStatus.textContent = 'Die Wickelauflage konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
        } finally {
          cartBusy = false;
          updateCartButton();
        }
      });

      update();
    });
  });
})();
